import { adminAPIService, adminFileDownloadService } from './index'

const route = 'memberships'

export const getRewards = (page = 1, size = 20) => {
  const params = {
    page,
    size,
  }

  return adminAPIService({
    url: `${route}/rewards/redemptions`,
    method: 'get',
    params,
  })
}

export const sendCouponCode = (rewardId, couponCode) => {
  const body = `coupon_code=${couponCode}`

  return adminAPIService({
    url: `${route}/rewards/redemptions/${rewardId}`,
    method: 'post',
    data: body,
  })
}

export const getPointStatus = ({
  startDate,
  endDate,
  uniquename,
  email,
}, page = 1, size = 20) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
    page,
    size,
  }
  console.log(params)

  if (uniquename) {
    params.uniquename = uniquename
  }
  if (email) {
    params.email = email
  }

  return adminAPIService({
    url: `${route}/point_status`,
    method: 'get',
    params,
  })
}

export const generatePointStatusCSV = ({
  startDate,
  endDate,
  uniquename,
  email,
}) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  }

  if (uniquename) {
    params.uniquename = uniquename
  }
  if (email) {
    params.email = email
  }

  return adminFileDownloadService({
    url: `${route}/point_status`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}

export const getDailyOptInCount = ({
  startDate,
  endDate,
}, page = 1, size = 20) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
    page,
    size,
  }

  return adminAPIService({
    url: `${route}/member_opt_in_count`,
    method: 'get',
    params,
  })
}

export const generateDailyOptInCountCSV = ({
  startDate,
  endDate,
}) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  }

  return adminFileDownloadService({
    url: `${route}/member_opt_in_count`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}

export const OrderAppealsAPI = {
  /*
    @params
      - is_valid
      - is_settle
      - page
      - size
  */
  getList(params) {
    return adminAPIService({
      url: `${route}/rewards/order_appeals`,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/rewards/order_appeals/${id}`,
      method: 'get',
    })
  },
  update(orderAppeal) {
    const body = `json=${encodeURIComponent(JSON.stringify(orderAppeal))}`
    return adminAPIService({
      url: `${route}/rewards/order_appeals/${orderAppeal.id}`,
      method: 'post',
      data: body,
    })
  },
}
